(function () {
  'use strict';

  /* ================================================================
     NewPharma - descuento por cantidad (packs) en la ficha

     Reemplaza al widget de Fast Bundle. Al elegir un tramo escribe la
     cantidad en el formulario de compra.

     DONDE ESCRIBE. El input que se ve es `name="quantity-js"`, pero el
     que viaja al carrito es un `<input type="hidden" name="quantity">`
     que emite payment-buttons.liquid. component-product-form.js lo lee
     en `cacheSubmissionElements()`, y eso corre EN EL SUBMIT: por eso
     alcanza con dejarlo al dia y no hay que engancharse a ningun evento
     interno del tema. Se actualizan los dos, para que el selector de
     cantidad muestre lo mismo que se va a comprar.

     EL DESCUENTO NO SE APLICA ACA. Este archivo solo muestra el precio
     esperado y manda la cantidad. Quien cobra menos es un descuento
     automatico del Admin.
     ================================================================ */

  function dinero(centavos, formato) {
    var pesos = Math.round(centavos / 100);
    var txt = pesos.toLocaleString('es-CL');
    if (!formato) return '$' + txt;
    // Se reusa el formato de la tienda, reemplazando el marcador de Liquid
    return formato.replace(/\{\{\s*amount[_a-z]*\s*\}\}/g, txt);
  }

  function leerJSON(cont, selector) {
    var el = cont.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function arrancar(cont) {
    if (cont.dataset.npPacksActivo) return;
    cont.dataset.npPacksActivo = '1';

    // En modo variante no se toca la cantidad: lo maneja el bloque delegado
    // que esta al final de este archivo.
    if (cont.dataset.npModo === 'variante') return;

    var form = document.getElementById(cont.dataset.formId) ||
               cont.closest('form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var precios = leerJSON(cont, '[data-np-precios]') || {};
    var formato = leerJSON(cont, '[data-np-formato]') || '';
    var packs = Array.prototype.slice.call(cont.querySelectorAll('[data-np-pack]'));
    if (!packs.length) return;

    function precioBase() {
      var sel = form.querySelector('[name="id"]');
      var p = sel && precios[sel.value];
      if (p) return p;
      // Un solo precio en el mapa: no hay variantes que elegir.
      var vals = Object.keys(precios).map(function (k) { return precios[k]; });
      return vals.length ? vals[0] : 0;
    }

    function repintar() {
      var base = precioBase();
      if (!base) return;
      packs.forEach(function (p) {
        var u = parseInt(p.dataset.unidades, 10) || 1;
        var pct = parseInt(p.dataset.pct, 10) || 0;
        var unit = Math.floor(base * (100 - pct) / 100);
        var t = p.querySelector('[data-np-total]');
        var b = p.querySelector('[data-np-bruto]');
        var c = p.querySelector('[data-np-unit]');
        if (t) t.textContent = dinero(unit * u, formato);
        if (b) b.textContent = dinero(base * u, formato);
        if (c) c.textContent = dinero(unit, formato);
      });
    }

    function fijarCantidad(u) {
      // El que de verdad viaja al carrito
      form.querySelectorAll('[name="quantity"]').forEach(function (i) { i.value = u; });
      // Y el visible, para que no muestre otra cosa
      var vis = form.querySelector('.js-qty__num') ||
                document.querySelector('[data-section-id] .js-qty__num');
      if (vis && vis.value !== String(u)) {
        vis.value = u;
        vis.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (window.eventBus && typeof window.eventBus.emit === 'function') {
        window.eventBus.emit('qty:change', { value: String(u) });
      }
    }

    function elegir(pack) {
      packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle('is-activo', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      fijarCantidad(parseInt(pack.dataset.unidades, 10) || 1);
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () { elegir(p); });
    });

    // Si el cliente toca el +/- del tema, el tramo elegido deja de ser cierto
    var vis = form.querySelector('.js-qty__num') || document.querySelector('.js-qty__num');
    if (vis) {
      vis.addEventListener('change', function () {
        var u = parseInt(vis.value, 10) || 1;
        form.querySelectorAll('[name="quantity"]').forEach(function (i) { i.value = u; });
        var coincide = null;
        packs.forEach(function (p) {
          if ((parseInt(p.dataset.unidades, 10) || 1) === u) coincide = p;
        });
        packs.forEach(function (p) {
          var on = p === coincide;
          p.classList.toggle('is-activo', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    }

    // Al cambiar de variante cambia el precio base
    var sel = form.querySelector('[name="id"]');
    if (sel) sel.addEventListener('change', repintar);

    var activo = cont.querySelector('[data-np-pack].is-activo') || packs[0];
    elegir(activo);
    repintar();
  }

  function init() {
    document.querySelectorAll('[data-np-packs]').forEach(arrancar);
    observar();
    destacarRecomendacionInicial();
  }

  /* ================================================================
     PRESELECCION DEL PACK DE 2

     Al entrar a la ficha venia elegida la variante de 1 unidad, que es
     la que Shopify da por defecto. La clienta pidio que arranque en el
     pack de 2, que es el que conviene y el que mas se vende.

     NO SE RESPETA SI LA URL TRAE `?variant=`. Un enlace a una variante
     concreta -de una campana, del carrito, de un compartido- tiene que
     abrir en esa y no en otra.

     LA BANDERA ES DE MODULO, NO DEL ELEMENTO. El bloque sale con
     `data-updates-on-change`, asi que el tema lo REDIBUJA al cambiar de
     variante: una marca puesta en el contenedor se perderia en ese
     redibujado y, como `init` vuelve a correr en `shopify:section:load`,
     podria reelegir el 2 pisando lo que el cliente acababa de tocar.

     Se hace con un clic al radio del tema, igual que una eleccion
     manual, para que el precio, la URL y la disponibilidad los siga
     manejando el tema.
     ================================================================ */
  var yaDestacadoInicial = false;

  function destacarRecomendacionInicial() {
    if (yaDestacadoInicial) return;
    if (/[?&]variant=/.test(window.location.search)) return;

    var aplicado = false;
    document.querySelectorAll('[data-np-packs][data-np-modo="variante"]').forEach(function (cont) {
      var packs = Array.prototype.slice.call(cont.querySelectorAll('[data-np-pack]'));
      var seleccionado = null;
      var recomendado = null;

      packs.forEach(function (pack) {
        if (pack.getAttribute('aria-checked') === 'true') seleccionado = pack;
        if (parseInt(pack.dataset.unidades, 10) === 2 && !pack.disabled) recomendado = pack;
      });

      if (!seleccionado || !recomendado || seleccionado === recomendado) return;
      if (parseInt(seleccionado.dataset.unidades, 10) !== 1) return;

      packs.forEach(function (pack) {
        pack.classList.toggle('is-activo', pack === recomendado);
        pack.setAttribute('aria-checked', pack === seleccionado ? 'true' : 'false');
      });

      cont.dataset.npPacksDestacadoInicial = 'true';
      aplicado = true;
    });

    if (aplicado) yaDestacadoInicial = true;
  }

  /* ================================================================
     MODO VARIANTE

     Cuando el producto tiene variantes "1 unidad / 2 unidades / ...", la
     tarjeta NO escribe cantidad ni precio: le hace clic al radio que el
     tema ya emite para esa opcion. De ahi en adelante el precio, la URL,
     la imagen y la disponibilidad los maneja el tema, que es quien sabe.

     VA DELEGADO EN DOCUMENT A PROPOSITO. El bloque sale con
     `data-updates-on-change`, o sea que el tema lo REDIBUJA al cambiar de
     variante: un listener puesto sobre el boton se perderia en el primer
     cambio. Delegado sobrevive a los redibujados.
     ================================================================ */
  function radioDeOpcion(cont, valor) {
    var ambito = cont.closest('.product-details-wrapper') ||
                 cont.closest('[data-section-id]') || document;
    var radios = ambito.querySelectorAll('.swatch input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === valor) return radios[i];
    }
    return null;
  }

  function marcar(cont, pack) {
    cont.querySelectorAll('[data-np-pack]').forEach(function (p) {
      var on = p === pack;
      p.classList.toggle('is-activo', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (ev) {
    var pack = ev.target.closest ? ev.target.closest('[data-np-pack][data-np-opcion]') : null;
    if (!pack || pack.disabled) return;
    var cont = pack.closest('[data-np-packs]');
    if (!cont || cont.dataset.npModo !== 'variante') return;

    yaDestacadoInicial = true;
    delete cont.dataset.npPacksDestacadoInicial;
    var radio = radioDeOpcion(cont, pack.dataset.npOpcion);
    if (radio && !radio.checked) radio.click();
    marcar(cont, pack);
  });

  function sincronizar() {
    document.querySelectorAll('[data-np-packs][data-np-modo="variante"]').forEach(function (cont) {
      if (cont.dataset.npPacksDestacadoInicial === 'true') return;
      var ambito = cont.closest('.product-details-wrapper') ||
                   cont.closest('[data-section-id]') || document;
      var radios = ambito.querySelectorAll('.swatch input[type="radio"]');
      var valor = null;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) { valor = radios[i].value; break; }
      }
      if (valor === null) return;

      var destino = null, yaBien = false;
      cont.querySelectorAll('[data-np-pack]').forEach(function (p) {
        if (p.dataset.npOpcion === valor) {
          destino = p;
          yaBien = p.classList.contains('is-activo');
        }
      });
      // Sin esta salida, marcar() dispararia otra mutacion y el
      // observador se llamaria a si mismo sin fin.
      if (!destino || yaBien) return;
      marcar(cont, destino);
    });
  }

  document.addEventListener('change', function (ev) {
    var r = ev.target;
    if (!r || r.type !== 'radio' || !r.closest || !r.closest('.swatch')) return;
    var ambito = r.closest('.product-details-wrapper') || r.closest('[data-section-id]');
    var cont = r.closest('[data-np-packs][data-np-modo="variante"]');
    if (!cont && ambito) cont = ambito.querySelector('[data-np-packs][data-np-modo="variante"]');
    if (cont) {
      yaDestacadoInicial = true;
      delete cont.dataset.npPacksDestacadoInicial;
    }
    sincronizar();
  });

  /* El redibujado del tema no emite ningun evento propio, asi que se
     observa el DOM. `subtree` porque lo que se reemplaza es el bloque
     entero, no un hijo suelto. */
  function observar() {
    var raiz = document.querySelector('.product-details-wrapper') ||
               document.querySelector('[data-section-id]');
    if (!raiz || raiz.dataset.npObservado) return;
    raiz.dataset.npObservado = '1';
    new MutationObserver(function () { sincronizar(); })
      .observe(raiz, { childList: true, subtree: true });
  }

  /* ================================================================
     SUGERENCIA DE PACK EN EL CARRITO

     El bloque lo dibuja cart-drawer.liquid; aca solo se aplica. El boton
     trae el carrito deseado ya resuelto en `data-np-updates`, como pares
     "variantId":cantidad SIN las llaves (asi el atributo no pelea con la
     sintaxis de Liquid). Se mandan TODOS los tramos del producto, los que
     quedan en cero incluidos: /cart/update.js fija cantidades absolutas,
     de modo que una sola llamada deja el carrito exactamente como debe.
     ================================================================ */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-np-aplicar]') : null;
    if (!btn || btn.disabled) return;

    var crudo = btn.getAttribute('data-np-updates');
    if (!crudo) return;
    var updates;
    try { updates = JSON.parse('{' + crudo + '}'); } catch (e) { return; }

    btn.disabled = true;
    btn.classList.add('is-cargando');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update');
      return r.json();
    }).then(function () {
      // `render:cart:drawer` redibuja SOLO el cajon. Si el boton esta en la
      // pagina /cart, la tabla y la propia sugerencia quedarian viejas en
      // pantalla aunque el carrito ya cambio: ahi hay que recargar.
      var enCajon = !!(btn.closest && btn.closest('[data-cart-dynamic-content]'));
      if (enCajon && window.eventBus && typeof window.eventBus.emit === 'function') {
        window.eventBus.emit('render:cart:drawer');
      } else {
        window.location.reload();
      }
    }).catch(function () {
      btn.disabled = false;
      btn.classList.remove('is-cargando');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // El editor redibuja la seccion al cambiar un ajuste
  document.addEventListener('shopify:section:load', init);
})();
